{
  "colorFormat": "Spalvų formatas",
  "hex": "Hex",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
